import { render, staticRenderFns } from "./sixth.vue?vue&type=template&id=661504a5&scoped=true"
import script from "./sixth.vue?vue&type=script&lang=js"
export * from "./sixth.vue?vue&type=script&lang=js"
import style0 from "./sixth.vue?vue&type=style&index=0&id=661504a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661504a5",
  null
  
)

export default component.exports